import { animate, state, style, transition, trigger } from '@angular/animations';

export const bottomSlideAnimation = trigger('slideUpDown', [
  state(
    'closed',
    style({
      transform: 'translateY(100%)',
    }),
  ),
  state(
    'open',
    style({
      transform: 'translateY(0)',
    }),
  ),
  transition('closed => open', [animate('300ms ease-out')]),
  transition('open => closed', [animate('300ms ease-in')]),
]);

